import React, { useMemo } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { Flex, Pane } from '@leverege/ui-elements';
import DeviceLogin from "./DeviceLogin.js";
import DeviceCodeSuccess from "./DeviceCodeSuccess.js";
import { createOnConfirmUserCode, createOnLogin, defaultAdjustPath } from "./Util.js";
import { DEFAULT_LOGIN_OPTIONS } from "./Constants.js";
function ScreenWrapper({
  children
}) {
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "loginBackground",
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    align: "center",
    justify: "center",
    vFill: true
  }, children));
}
function LoginRoutesAuthenticated(props) {
  const {
    adjustPath = defaultAdjustPath,
    loginOpts,
    requestDeviceCodeOpts,
    postLoginUrl,
    router,
    afterRoutes,
    ...rest
  } = props;
  const onLoginOpts = useMemo(() => {
    return {
      login: {
        ...DEFAULT_LOGIN_OPTIONS,
        ...loginOpts
      },
      postLoginUrl,
      adjustPath
    };
  }, [loginOpts, postLoginUrl, adjustPath]);
  const login = useMemo(() => {
    return {
      ...DEFAULT_LOGIN_OPTIONS,
      onLogin: createOnLogin(onLoginOpts),
      ...rest,
      ...loginOpts
    };
  }, [loginOpts, onLoginOpts, rest]);
  const deviceLogin = useMemo(() => {
    return {
      ...login,
      path: '/login/device',
      onLogin: createOnLogin({
        ...onLoginOpts,
        postLoginUrl: '/login/device/success'
      }),
      onConfirmUserCode: createOnConfirmUserCode({
        clientId: requestDeviceCodeOpts?.clientId
      })
    };
  }, [login, onLoginOpts, requestDeviceCodeOpts?.clientId]);
  return /*#__PURE__*/React.createElement(Switch, {
    location: router.location
  }, /*#__PURE__*/React.createElement(Route, {
    key: "deviceLogin",
    path: adjustPath(deviceLogin.path || '/login/device'),
    exact: true,
    render: () => {
      return /*#__PURE__*/React.createElement(ScreenWrapper, null, /*#__PURE__*/React.createElement(DeviceLogin, deviceLogin));
    }
  }), /*#__PURE__*/React.createElement(Route, {
    key: "deviceLoginSuccess",
    exact: true,
    path: adjustPath(deviceLogin.successPath || '/login/device/success'),
    render: props => {
      return /*#__PURE__*/React.createElement(ScreenWrapper, null, /*#__PURE__*/React.createElement(DeviceCodeSuccess, props));
    }
  }), afterRoutes);
}
export default connect((state, props) => {
  return {
    router: props.router || state.router
  };
})(LoginRoutesAuthenticated);